import React, { useState } from 'react';
import { Table, Grid, Button, Icon, Message } from 'semantic-ui-react';
import { FieldArray, ErrorMessage, Field as Fieldmik, } from 'formik';
import Axios from 'axios';
import cogoToast from 'cogo-toast';

import APP_CONSTANTS from '../../../../config/constants';

//Formik Inputs
import SupportDocDropdown from '../../../dropdowns/supportDocDropdown';
import UploadFile from '../../../formikInput/fileUpload';


const SupportingDoc = ({ editMode, viewMode }) => {

    const [isLoading, setIsLoading] = useState(false)

    const duplicateSupportDocCheck = (supportDoc) => {
        if (supportDoc.length > 1) {
            for (var i = 0; i < supportDoc.length; i++) {
                for (var j = 0; j < supportDoc.length; j++) {
                    if (i != j) {
                        if (supportDoc[i].supportingDocumentTypeName === supportDoc[j].supportingDocumentTypeName) {
                            console.log("Duplicate Check =========>", supportDoc[i].supportingDocumentTypeName, supportDoc[j].supportingDocumentTypeName)
                            return true
                        } else {
                            return false
                        }
                    }
                }
            }
        } else {
            return false
        }
    }

    const handleUpload = (document, fileDownloadName, setFieldValue, supportDoc) => {

        if (duplicateSupportDocCheck(supportDoc)) {
            cogoToast.error("Supporting Document Name is duplicate")
        } else {

            setIsLoading(true)
            let token = localStorage.getItem('isloggedIn')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNumber')

            const data = JSON.stringify({
                "customerNo": customerNo,
                "userId": userId,
                "billId": document.billId,
                "supportingDocumentTypeId": document.supportingDocumentTypeId,
                "supportingDocumentTypeName": document.supportingDocumentTypeName,
                "fileUrl": document.fileUrl.base64.split(',')[1]
            });

            Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/uploadBillSupportingDocumentType`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                if (response.data.status === 1) {
                    cogoToast.success(response.data.message)
                    setFieldValue(fileDownloadName, response.data.data)
                }

                setIsLoading(false)
            }))
                .catch(error => console.log(error))
            setIsLoading(false)
            console.log("Document", document)

        }


    };

    const handleDownload = (fileUrl) => {
        window.open(fileUrl)
    }

    return (
        <FieldArray
            name="supportDoc">
            {({ push, remove, form }) => {

                const { initialValues, values, setFieldValue } = form
                const { supportDoc } = values

                return (
                    <div className="ui form tiny">
                        <Table className="w3-small" basic>
                            <Table.Header>
                                <Table.Row >
                                    <Table.HeaderCell className="labelName p-bold-600">Supporting Document Name</Table.HeaderCell>
                                    {viewMode ? "" :
                                        <>
                                            <Table.HeaderCell className="labelName p-bold-600">Select Document</Table.HeaderCell>
                                            <Table.HeaderCell className="labelName p-bold-600">Upload</Table.HeaderCell>
                                        </>
                                    }
                                    {(editMode || viewMode) && <Table.HeaderCell className="labelName p-bold-600">Download</Table.HeaderCell>}
                                </Table.Row>
                            </Table.Header>
                            {supportDoc.length === 0 && <Message size="mini" color="yellow" className="ml-2">No Document(s) Found</Message>}

                            <Table.Body>
                                {supportDoc.map((document, documentIndex) => {
                                    return (
                                        <>
                                            <Table.Row verticalAlign="middle" key={documentIndex} >
                                                <Table.Cell >
                                                    {console.log("Form Values ====>", form)}
                                                    <Fieldmik
                                                        component={SupportDocDropdown}
                                                        viewMode={viewMode}
                                                        placeholder="Document Type"
                                                        name={`supportDoc[${documentIndex}].supportingDocumentTypeName`}
                                                        supportDocId={`supportDoc[${documentIndex}].supportingDocumentTypeId`}
                                                        value={document.supportingDocumentTypeName}
                                                    />
                                                    <ErrorMessage name={`supportDoc[${documentIndex}].supportingDocumentTypeName`}>
                                                        {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                    </ErrorMessage>
                                                </Table.Cell>
                                                {viewMode ?
                                                    ""
                                                    :
                                                    <>
                                                        <Table.Cell>
                                                            <Fieldmik component={UploadFile} name={`supportDoc[${documentIndex}].fileUrl`} size="tiny" typer={[".pdf"]} value={document.fileUrl} buttonName={document.fileUrl ? "Selected" : "Select"} />
                                                            {document?.fileUrl?.fileList?.[0] ? <div className="w3-text-green w3-tiny font-weight-bold mt-1" style={{ maxWidth: "200px" }} >{document.fileUrl.fileList[0].name}</div> : ""}<br />
                                                            {document?.fileUrl?.fileList?.[0] ? <strong className="w3-text-red w3-tiny font-weight-bold">{document.fileUrl.fileList[0].size > 5000000 ? "File needs to be below 5mb." : ""}</strong> : ""}<br />
                                                            <ErrorMessage name={`supportDoc[${documentIndex}].fileUrl`}>
                                                                {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                            </ErrorMessage>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {console.log("FileSize =======> ", document.fileUrl?.fileList?.[0].size)}
                                                            <Button
                                                                size="tiny"
                                                                icon
                                                                loading={isLoading}
                                                                basic
                                                                onClick={() => handleUpload(document, `supportDoc[${documentIndex}].fileDownload`, setFieldValue, supportDoc)}
                                                                disabled={!(document.supportingDocumentTypeName && document.fileUrl && document.fileUrl?.fileList?.[0].size < 5000000)}
                                                            >
                                                                <Icon name="upload" color="green" />
                                                                {document.fileDownload ? " Replace" : " Upload"}
                                                            </Button>
                                                        </Table.Cell>
                                                    </>
                                                }
                                                <Table.Cell>
                                                    {(editMode || viewMode) && <Button disabled={!document.fileDownload} onClick={() => handleDownload(document.fileDownload)} type="button" basic size="tiny" icon className="ml-2">
                                                        <Icon color="blue" name="download" />
                                                    </Button>}
                                                    {supportDoc.length > 1 && !viewMode ?
                                                        <Button onClick={() => remove(documentIndex)} type="button" basic size="tiny" icon className="ml-2">
                                                            <Icon color="red" name="trash" />
                                                        </Button>
                                                        :
                                                        ""
                                                    }
                                                </Table.Cell>
                                            </Table.Row>

                                        </>
                                    )
                                })}
                            </Table.Body>
                            {supportDoc.length < 4 && !viewMode ?
                                <Grid >
                                    <Grid.Column>
                                        <Button className="ml-4 mb-2" type="button" onClick={() => push({ supportingDocumentTypeId: '0', supportingDocumentTypeName: '', fileUrl: '', billId: values.billId })} size="mini" basic color="blue">
                                            + Add Document
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                :
                                ""
                            }

                        </Table>
                    </div>
                )

            }}

        </FieldArray>
    )
}

export default SupportingDoc;